import styles from "./ProgressBar.module.css";

type ProgressBarProps = {
  progress: number;
  categoryName: string;
  numberOfQuestions: number;
  evaluatorType: string;
  autoCompleted?: boolean;
};

const clampProgress = (value: number) => Math.min(100, Math.max(0, value || 0));

export default function ProgressBar({
  progress,
  categoryName,
  numberOfQuestions,
  evaluatorType,
  autoCompleted = false,
}: ProgressBarProps) {
  const normalizedProgress = clampProgress(progress);
  const totalQuestions = Math.max(0, numberOfQuestions || 0);
  const answeredQuestions = Math.min(
    totalQuestions,
    Math.round((normalizedProgress / 100) * totalQuestions)
  );

  let progressDescription = "";

  if (totalQuestions > 0) {
    if (autoCompleted && answeredQuestions === totalQuestions) {
      progressDescription =
        evaluatorType === "Client"
          ? "You have answered all questions"
          : "Já respondeste a todas as perguntas";
    } else {
      progressDescription =
        evaluatorType === "Client"
          ? `Questions answered: ${answeredQuestions} of ${totalQuestions}`
          : `Perguntas respondidas: ${answeredQuestions} de ${totalQuestions}`;
    }
  } else {
    progressDescription =
      evaluatorType === "Client"
        ? `Progress: ${Math.round(normalizedProgress)}%`
        : `Progresso em ${Math.round(normalizedProgress)}%`;
  }

  return (
    <div
      className={styles.wrapper}
      aria-label={`Progresso da categoria ${categoryName}`}
    >
      <h3 className={styles.categoryName}>{categoryName}</h3>

      <div
        className={styles.progressTrack}
        role="progressbar"
        aria-valuenow={Math.round(normalizedProgress)}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuetext={progressDescription}
      >
        <div
          className={styles.progressFill}
          style={{ width: `${normalizedProgress}%` }}
        />
      </div>

      <div className={styles.information}>
        <p className={styles.questionsAnswered}>{progressDescription}</p>

        <p className={styles.percentage}>{Math.round(normalizedProgress)}%</p>
      </div>
    </div>
  );
}
